export enum UserRole {
  OWNER = "owner",
  USER = "user",
  PENDING = "pending",
}
